export const PLAN_DEFINITIONS = {
  free: {
    id: "free",
    name: "Basic",
    priceLabel: "$0",
    intervalLabel: "Free forever",
    monthlyPrice: 0,
    trialDays: 0,
    userLimit: 1,
    programLimit: 3,
    analyticsTier: "starter",
    hasAdvancedAnalytics: false,
    analyticsSummary: "Starter analytics for clicks, conversions, estimated revenue, payout, and EPC across a few links.",
    analyticsFeatures: [
      "Click and conversion tracking",
      "Estimated revenue, payout, and EPC",
      "Starter dashboard summary"
    ],
    description: "Best for a solo creator getting started with a few content links."
  },
  pro: {
    id: "pro",
    name: "Pro",
    priceLabel: "$19",
    intervalLabel: "per month",
    monthlyPrice: 19,
    trialDays: 7,
    userLimit: 1,
    programLimit: 25,
    analyticsTier: "advanced",
    hasAdvancedAnalytics: true,
    analyticsSummary: "Advanced analytics for comparing content, platforms, revenue, profit, goals, and trends.",
    analyticsFeatures: [
      "Ranked content and platform comparisons",
      "Finance, profit, weekly growth, and trend charts",
      "Custom goals and milestone tracking"
    ],
    description: "For a solo creator ready to compare more content, platforms, and campaigns."
  },
  team: {
    id: "team",
    name: "Team",
    priceLabel: "$69",
    intervalLabel: "per month",
    monthlyPrice: 69,
    trialDays: 0,
    userLimit: 5,
    programLimit: 100,
    analyticsTier: "advanced",
    hasAdvancedAnalytics: true,
    analyticsSummary: "Advanced analytics plus team workspace comparisons, leaderboards, and member-level performance.",
    analyticsFeatures: [
      "Everything in Pro analytics",
      "Team leaderboards and member performance",
      "Workspace and member-level goals, profit, and trends"
    ],
    description: "For a small creator team sharing one workspace and a larger content portfolio."
  }
};

export const DEFAULT_PLAN_ID = "free";

export function getPlanDefinition(planId) {
  return PLAN_DEFINITIONS[planId] || PLAN_DEFINITIONS[DEFAULT_PLAN_ID];
}
